"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MFA_ERROR_CODES = exports.MFA_SETTINGS = exports.MFA_TOKEN_STATUS = void 0;
exports.MFA_TOKEN_STATUS = {
    PENDIENTE: 1,
    USADO: 2,
    EXPIRADO: 3,
};
exports.MFA_SETTINGS = {
    CODE_LENGTH: 6,
    CODE_TTL_SECONDS: 180,
    SESSION_TTL_SECONDS: 600,
    MAX_CODE_ATTEMPTS: 3,
    RESEND_COOLDOWN_SECONDS: 60,
    MAX_RESENDS_PER_SESSION: 3,
    MAX_FAILED_CODES_PER_USER: 10,
    USER_FAILED_CODES_WINDOW_SECONDS: 3600, // M-1 (DP-A1, anexo 2026-10)
};
exports.MFA_ERROR_CODES = {
    SESSION_INVALID: 'SESSION_INVALID',
    SESSION_EXPIRED: 'SESSION_EXPIRED',
    CODE_INCORRECT: 'CODE_INCORRECT',
    CODE_EXPIRED: 'CODE_EXPIRED',
    CODE_MAX_ATTEMPTS: 'CODE_MAX_ATTEMPTS',
    RESEND_COOLDOWN: 'RESEND_COOLDOWN',
    RESEND_LIMIT: 'RESEND_LIMIT',
    EMAIL_NOT_CONFIGURED: 'EMAIL_NOT_CONFIGURED',
    EMAIL_SEND_FAILED: 'EMAIL_SEND_FAILED',
    ACCOUNT_BLOCKED: 'ACCOUNT_BLOCKED',
    ACCOUNT_INACTIVE: 'ACCOUNT_INACTIVE',
};
